import { render, staticRenderFns } from "./WeightCarryRule.vue?vue&type=template&id=2995b32f&scoped=true&"
import script from "./WeightCarryRule.vue?vue&type=script&lang=js&"
export * from "./WeightCarryRule.vue?vue&type=script&lang=js&"
import style0 from "./WeightCarryRule.vue?vue&type=style&index=0&id=2995b32f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995b32f",
  null
  
)

export default component.exports